// extracted by mini-css-extract-plugin
export default {"products":"gt-z","card":"ht-z","oosMessaging":"it-z"};